import React, { useEffect, useState } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Notification from "./Notification";
import { collection, onSnapshot } from "firebase/firestore";
import { firestore as db } from "../firebase.config";

const NotificationBell = ({ isSuperAdmin }) => {
  const [open, setOpen] = useState(false);
  const [unansweredCount, setUnansweredCount] = useState(0);

  useEffect(() => {
    // Listen for realtime updates from Firestore
    const unsubscribe = onSnapshot(
      collection(db, "unanswered_questions"),
      (snapshot) => {
        setUnansweredCount(snapshot.size);
      },
    );

    return () => unsubscribe();
  }, []);

  if (!isSuperAdmin) return null;

  return (
    <>
      <IconButton color="inherit" onClick={() => setOpen(true)}>
        <Badge badgeContent={unansweredCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Notification
        open={open}
        message={
          unansweredCount > 0
            ? `You have ${unansweredCount} unanswered question(s).`
            : "No unanswered questions."
        }
        severity={unansweredCount > 0 ? "info" : "success"}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default NotificationBell;
